import {useFormik} from 'formik';
import {useState} from 'react';
import {EditStoryParams, StoryDetailedModel, StoryModel, useBlockStoryById} from '../../../entities';
import * as Yup from 'yup';
import {AxiosError} from 'axios';

type UseEditStoryFormProps = {
  blockId: string;
  storyId: string | null;
  setOpen: (open: boolean) => void;
  story?: StoryDetailedModel | StoryModel;
};

export const useEditStoryForm = ({blockId, storyId, setOpen, story}: UseEditStoryFormProps) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const {updateStoryMutation} = useBlockStoryById(blockId, storyId || '');

  const onSubmit = async (values: {title: string; priority: number}) => {
    if (!storyId) return;

    setErrorMessage(null);
    try {
      const storyData: EditStoryParams = {
        blockId,
        storyId,
        title: values.title,
        priority: values.priority,
      };
      await updateStoryMutation.mutateAsync(storyData);
      setOpen(false);
    } catch (error: any) {
      setErrorMessage(error?.response?.data?.detail || 'Произошла ошибка при обновлении истории');
    }
  };

  const formik = useFormik({
    initialValues: {
      title: story?.title || '',
      priority: story?.priority || 0,
    },
    validationSchema: Yup.object({
      title: Yup.string().max(256, 'Заголовок не должен превышать 256 символов').required('Заголовок обязателен'),
      priority: Yup.number().required('Приоритет обязателен'),
    }),
    onSubmit,
  });

  return {
    ...formik,
    isLoading: updateStoryMutation.isPending,
    submitError: updateStoryMutation.error
      ? (updateStoryMutation.error as AxiosError<ApiError>).response?.data
      : undefined,
    errorMessage,
    submitForm: () => formik.handleSubmit(),
  };
};
